module.exports = __webpack_public_path__ + "img/pimploy.b3a62b04.svg";